import api from "../services/api";
import store from "../../../store";

export default {
  sendResetEmail: async function ({ commit }, payload) {
    await api.sendResetEmail(payload);
  },
  setPassword: async function ({ commit }, payload) {
    await api.setPassword(payload.password, payload.token);
  },
  changeTempPassword: async function ({ commit }, payload) {
    return api.changeTempPassword(payload.password).then(() => {
      commit("core/tempPasswordChanged", null, { root: true });
    });
  },
  login: async function ({ commit }, payload) {
    await api.login(payload.userName, payload.password);
  },
  logout: async function () {
    await api.logout();
    store.commit("core/resetAbilites");
  },
  verifyTwoFactorAuth: async function ({ commit }, payload) {
    return api.verifyTwoFactorAuth(payload);
  },
  resendTwoFactorAuthCode: async function ({ commit }, payload) {
    return api.resendTwoFactorAuthCode()
  },
  checkStatusTwoFactorAuth: async function ({ commit }, payload) {
    return api.checkStatusTwoFactorAuth()
  }
};
